
import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        id: 'ranking',
        name: 'ranking',
        title: i18n.t('Ranking'),
        width: "50px",
        titleClass: "right aligned",
        dataClass: "right aligned",
    },
    {
        id: 'image',
        name: 'image',
        title: i18n.t('Image'),
        width: "90px",
        visible: true,
        togglable: true
    },
    {
        id: 'name',
        name: 'name',
        title: i18n.t('Category Name'),
        visible: true,
        togglable: true
    },
    {
        id: 'quantity',
        name: 'quantity',
        title: i18n.t('Sold QTY'),
        filterable: true,
        togglable: true,
        width: "150px",
        // sortField: "quantity",
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'price',
        name: 'price',
        title: i18n.t('_reportscategory.Product Sales'),
        filterable: true,
        togglable: true,
        width: "150px",
        // sortField: "price",
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'discount',
        name: 'discount',
        title: i18n.t('Product Discount'),
        filterable: true,
        togglable: true,
        width: "150px",
        // sortField: "discount",
        formatter: (data) => {
            return formatNumberDigit(data);
        },
    },
    {
        id: 'total',
        name: 'total',
        title: i18n.t('Total Product Sales'),
        filterable: true,
        togglable: true,
        width: "150px",
        // sortField: "total",
        formatter: (data) => {
            return formatNumberDigit(data);
        },
    },
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/FieldsProductCategory.js